module.exports = __webpack_public_path__ + "img/team.98845b3c.svg";